// src/components/Banner/Banner.js
import "./Banner.scss";

function Banner({ img, title, subtitle, alt }) {
  return (
    <div className="Banner">
      <img src={img} className="banner-image" alt={alt} />

      <div className="overlay">
        <h1 className="hero-title">{title}</h1>
        <p className="hero-subtitle">{subtitle}</p>
      </div>
    </div>
  );
}
export default Banner;

